export class NewGroupMessageForm {

  constructor(public vehicles: number[],
              public messageText: string) {
  }

}
